export default __webpack_public_path__ + "static/media/d0c63a83098608ab80e1e391a299ebca.png";